var _a, _b;
import { useCallback } from 'react';
import trackerFactoryWithoutDevPrefix from '@fandom/tracking-metrics/tracking/';
import { getCookieByName } from 'utils/getCookieByName';
const b2 = getCookieByName('_b2');
const vertical = (_b = (_a = window.SilverSurferSDK.getContext()) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.productCategory;
const userId = window.SilverSurferSDK.getContext().user.id;
const lc = window.mw.config.get('wgContentLanguage');
export const dwTracker = trackerFactoryWithoutDevPrefix({
    sendToDW: true,
    dwPath: '__track/special/notifications',
    pushToDataLayer: true,
    addGlobalValues: true,
    shouldPrefixCategoryWithDev: false,
    category: 'pf-experiments: CMS-banner-notification',
    vertical,
    userId,
    b2,
    lc,
});
let impressionTracked = false;
const impressionNotTracked = () => {
    if (!impressionTracked) {
        impressionTracked = true;
        return true;
    }
    return false;
};
export const useNotificationsTracking = (moduleName, notification) => {
    const notificationId = notification.id.toString();
    const dwTrackingData = { label: notificationId, name: notification.name, author: notification.created_by };
    const trackNotificationEvent = useCallback((eventName) => {
        dwTracker(Object.assign({ action: eventName }, dwTrackingData));
    }, []);
    const trackNotificationImpression = useCallback(() => {
        if (impressionNotTracked()) {
            dwTracker(Object.assign({ action: 'impression' }, dwTrackingData));
        }
    }, []);
    return [trackNotificationImpression, trackNotificationEvent];
};
